import classNames from "classnames";
import React from "react";
import "./TicketNumber.css";
import { formatTicketNumber } from "../../common/utils/requests.util";

type Properties = {
    ticketNumber: number | null;
    className?: string;
};

const TicketNumber = function TicketNumber({ ticketNumber, className }: Properties) {
    return (
        <div className={classNames("ticket-number", className)}>
            #{formatTicketNumber(ticketNumber)}
        </div>
    );
};

export const TicketNumberSmall = function TicketNumberSmall({
    ticketNumber,
    className,
}: Properties) {
    return (
        <TicketNumber
            ticketNumber={ticketNumber}
            className={classNames("ticket-number--small", className)}
        />
    );
};

export default TicketNumber;
